import React from 'react';

function TutorialVisual({ variant, accent }) {
  const color = accent?.shape || 'bg-primary';
  const soft = accent?.soft || 'bg-blue-100';

  if (variant === 'ranking') {
    return (
      <div className="h-full w-full p-4 flex items-end gap-3">
        {[70, 46, 86].map((height, index) => (
          <div key={height} className="flex-1 flex flex-col justify-end gap-2">
            <div className={`${index === 2 ? color : soft} rounded-t-lg`} style={{ height: `${height}%` }} />
            <div className="h-2 rounded-full bg-surface/80" />
          </div>
        ))}
      </div>
    );
  }

  if (variant === 'chat') {
    return (
      <div className="h-full w-full p-4 flex flex-col justify-center gap-3">
        <div className={`w-3/4 ${color} rounded-2xl rounded-bl-sm h-10`} />
        <div className="w-2/3 ml-auto bg-surface/90 rounded-2xl rounded-br-sm h-10" />
        <div className={`w-1/2 ${soft} rounded-2xl rounded-bl-sm h-8`} />
      </div>
    );
  }

  if (variant === 'network') {
    return (
      <div className="relative h-full w-full">
        <div className={`absolute left-[18%] top-[24%] h-12 w-12 rounded-full ${color}`} />
        <div className="absolute right-[18%] top-[20%] h-10 w-10 rounded-full bg-surface/90" />
        <div className={`absolute right-[26%] bottom-[20%] h-14 w-14 rounded-full ${soft}`} />
        <div className="absolute left-[28%] bottom-[18%] h-8 w-8 rounded-full bg-surface/80" />
        <div className="absolute left-[32%] top-[35%] h-1 w-[38%] rotate-12 rounded-full bg-surface/70" />
        <div className="absolute left-[30%] bottom-[34%] h-1 w-[42%] -rotate-12 rounded-full bg-surface/70" />
      </div>
    );
  }

  if (variant === 'interest') {
    return (
      <div className="h-full w-full p-3 flex gap-2 items-stretch">
        <div className="flex-[1.2] grid grid-cols-2 gap-1.5 content-center">
          <div className={`col-span-2 h-10 rounded-lg ${color}`} />
          <div className={`h-8 rounded-lg ${soft}`} />
          <div className="h-8 rounded-lg bg-surface/85" />
        </div>
        <div className="flex-1 flex flex-col justify-center gap-2">
          <div className="h-14 rounded-xl bg-surface/90 border border-white/60 p-2">
            <div className={`h-2 w-3/4 rounded-full ${soft} mb-1.5`} />
            <div className={`h-2 w-1/2 rounded-full ${color}`} />
          </div>
          <div className="flex gap-1">
            <div className={`flex-1 h-2 rounded-full ${soft}`} />
            <div className="flex-1 h-2 rounded-full bg-surface/80" />
            <div className={`flex-1 h-2 rounded-full ${color}`} />
          </div>
        </div>
      </div>
    );
  }

  if (variant === 'report') {
    return (
      <div className="h-full w-full p-4 flex items-center justify-center">
        <div className="w-24 rounded-xl bg-surface/90 p-3 space-y-2">
          <div className={`h-4 rounded-full ${color}`} />
          <div className="h-2 rounded-full bg-surface-muted" />
          <div className="h-2 rounded-full bg-surface-muted" />
          <div className={`h-10 rounded-lg ${soft}`} />
        </div>
      </div>
    );
  }

  return (
    <div className="h-full w-full p-4 grid grid-cols-3 gap-3 items-end">
      <div className="h-1/2 rounded-lg bg-surface/80" />
      <div className={`h-3/4 rounded-lg ${soft}`} />
      <div className={`h-full rounded-lg ${color}`} />
      <div className="col-span-3 grid grid-cols-5 gap-2">
        {[0, 1, 2, 3, 4].map((dot) => (
          <div key={dot} className="aspect-square rounded-full bg-surface/80" />
        ))}
      </div>
    </div>
  );
}

export default TutorialVisual;
